
import ENDPOINT from "@/config/endpoint";
const replaceUrl = (path, baseUrl, replaceUrl, replaceUrlHttps) => {
  if (path && path.includes(replaceUrl)) {
    path = path.replace(replaceUrl, baseUrl)
  }

  if (path && path.includes(replaceUrlHttps)) {
    path = path.replace(replaceUrlHttps, baseUrl)
  }

  if (!path || path.includes('http') || path.includes('https')) {
    return path
  }
  return path.startsWith('/') ? `${baseUrl}${path}` : `${baseUrl}/${path}`
}

export const replaceUrlResource = (path) => {
  return replaceUrl(path, ENDPOINT.BACKEND_URL, 'http://125.212.204.221:8084', 'https://125.212.204.221:8084')
}